import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import { t } from 'ttag';
import useBasketContext from '../../../../../contexts/basket/useBasketContext';
import { money } from '../../../../../services/format';
import {CTA, CTAProps} from '../../../../general/Button';
import useOperatorContext from "../../../../../contexts/operator/useOperatorContext";

interface CartButtonProps {
    onClick: () => void;
    classes?: string;
    CTAProps?: CTAProps
}

const CartButton = ({ onClick, classes, CTAProps }: CartButtonProps) => {
    const operatorContext = useOperatorContext();
    const basketContext = useBasketContext();
    const [showAnim, setShowAnim] = useState(false);
    const [quantity, setQuantity] = useState(0);

    // Trigger animation on quantity change
    useEffect(() => {
        setShowAnim(false);
        if (quantity > 0) {
            setTimeout(() => {
                setShowAnim(true);
            }, 500)
        }
    }, [quantity])

    useEffect(() => {
        let count = 0;
        basketContext.basketItems.forEach(item => {
            count += item.quantity ?? 0;
        })
        setQuantity(count);
    }, [basketContext.basketItems])

    const renderButtonContent = () => {
        return (
            <>
                {t`View order`} { quantity > 0 && `(${quantity})` }
            </>
        );
    };

    return (
        <CTAButton
            disabled={basketContext.loading || !basketContext.basketItems.length}
            loading={basketContext.loading}
            onClick={onClick}
            className={classes}
            {...CTAProps}
        >
            {renderButtonContent()}
        </CTAButton>
    );
};

const CTAButton = styled(CTA)`
    height: 48px;
    display: inline-flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
`;

export default CartButton;
